import { createContext, useState, useContext, useEffect, useRef } from 'react';
import { getHelpRequestsCount, checkUser, getUserLatestViewedRelease, updateUserLatestReleaseVersion } from '../../data/dataApi';

const UserStateContext = createContext();

export const versionHistory = [
  { version: "1.1", date: "2025-01-06" },
  { version: "1.2", date: "2025-02-10" },
  { version: "2.0", date: "2026-01-21" },
  { version: "2.1", date: "2026-02-23" },
  { version: "2.2", date: "2026-03-04" },
  { version: "2.3", date: "2026-03-10" },
  { version: "2.4", date: "2026-07-28" }
];

export const UserStateProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [theme, setTheme] = useState();
  const [userRole, setUserRole] = useState();
  const [userId, setUserId] = useState(null);
  const [userLatestViewedRelease, setUserLatestViewedRelease] = useState(1.1);
  const [helpRequests, setHelpRequests] = useState(0);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userCapabilities, setUserCapabilities] = useState([]);

  const userCapabilitiesRetrieved = useRef(false);

  useEffect(() => {
    (async () => {
      const userResponse = await checkUser();

      setUser(userResponse);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await getHelpRequestsCount();
        const userResponse = await checkUser();

        setTheme(userResponse.theme);
        setUserId(userResponse.id);
        setUserRole(userResponse.role);
        setUserCapabilities(userResponse.capabilities || []);
        userCapabilitiesRetrieved.current = true;

        if (response.success) {
          setHelpRequests(response.data.rows[0].total_count);
        }

        const userLatestViewedReleaseResponse = await getUserLatestViewedRelease();

        if(userLatestViewedReleaseResponse.success) {
          setUserLatestViewedRelease(userLatestViewedReleaseResponse.data.rows[0].latest_viewed_release);
        }
      } catch (error) {
        console.error('Error occurred:', error);
      }
    })();
  }, [loggedIn]);

  return (
    <UserStateContext.Provider value={{ appVersion: versionHistory[versionHistory.length - 1].version, user, setUser, theme, setTheme, userId, setUserId, userRole, helpRequests, setLoggedIn, setHelpRequests, userCapabilities, userCapabilitiesRetrieved: userCapabilitiesRetrieved.current, userLatestViewedRelease, setUserLatestViewedRelease }}>
      {(!loggedIn || userId) && children}
    </UserStateContext.Provider>
  );
};

export const useUserState = () => {
  const context = useContext(UserStateContext);
  if (!context) {
    throw new Error('useUserState must be used within a UserStateProvider');
  }
  return context;
};